import { TableHeader, TableRow, TableHead } from "@/components/ui/Table";
import React, { type CSSProperties } from "react";
import { useDataTableContext } from "../Context/DataTableContext";
import { flexRender, type Header } from "@tanstack/react-table";
import { getHeaderWidthStyle } from "../utils/DataTableUtils";

const getCommonPinningStyles = (
  header: Header<unknown, unknown>,
): CSSProperties => {
  const { column } = header;
  const isPinned = column.getIsPinned();

  return {
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : undefined,
    position: isPinned ? "sticky" : "relative",
    width: column.getSize(),
    zIndex: isPinned ? 1 : 0,
    backgroundColor: isPinned ? "var(--background)" : undefined,
  };
};

export function HeaderCellsComponent() {
  const { table } = useDataTableContext();

  return (
    <TableHeader role="rowgroup">
      {table?.getHeaderGroups().map((headerGroup) => (
        <TableRow key={headerGroup.id} role="row">
          {headerGroup.headers.map((header, index) => {
            return (
              <TableHead
                key={`${header.id}-${index}`}
                role="columnheader"
                scope="col"
                data-column-id={header.id}
                aria-sort={
                  header.column.getIsSorted()
                    ? header.column.getIsSorted() === "desc"
                      ? "descending"
                      : "ascending"
                    : "none"
                }
                style={{
                  ...getHeaderWidthStyle(header),
                  ...getCommonPinningStyles(header),
                }}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
              </TableHead>
            );
          })}
        </TableRow>
      ))}
    </TableHeader>
  );
}
